import { render } from "./ChangePass.vue?vue&type=template&id=41872d66&scoped=true"
import script from "./ChangePass.vue?vue&type=script&lang=js"
export * from "./ChangePass.vue?vue&type=script&lang=js"

import "./ChangePass.vue?vue&type=style&index=0&id=41872d66&scoped=true&lang=css"

import exportComponent from "/home/hulk-suman/Music/Insidejob-admin-devlopment-1/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-41872d66"]])

export default __exports__